import { UPDATE_COMPANY_FEATURE_DATA } from 'constants/actions';

const DEFAULT_STATE = {
  brand_primary_color: null,
  company_email_domain: null,
};

const companyFeaturesReducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case UPDATE_COMPANY_FEATURE_DATA:
      return { ...state, ...action.company_feature_data };
    default:
      return state;
  }
};

export default companyFeaturesReducer;
